import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";

import { TransitionComponent } from "../components";

import { Blurb, AutoCloseIframeVideo } from "./components";
import { targetUrls, targetVideoUrls } from "../config";
import { useBlurbAction } from "./hooks";

const lottiePorpsProject = {
  width: {
    xs: 96,
    sm: 148,
    md: 192,
    lg: 256,
    xl: 320,
  },
};
const lottieProps = {
  width: {
    xs: 128,
    sm: 164,
    md: 192,
    lg: 256,
    xl: 320,
  },
};
const lottiePropsSmallHeight = {
  width: {
    xs: 128,
    sm: 128,
    md: 128,
    lg: 128,
    xl: 128,
  },
};
const lottiePropsProjectSmallHeight = {
  width: {
    xs: 96,
    sm: 96,
    md: 96,
    lg: 96,
    xl: 96,
  },
};
export function ExhibitionScreenWithoutRiver(props) {
  const matchesHeightLessThan700 = useMediaQuery("(max-height:700px)");

  const [showProject, setShowProject] = React.useState(false);
  const [hoveredRevolution, setHoveredRevolution] = React.useState(false);
  // const [transition, setTransition] = React.useState(false);
  // const [targetUrl, setTargetUrl] = React.useState("");
  // const { enqueueSnackbar } = useSnackbar();
  // const triggerTransition = (targetUrl, targetVideoUrl) => () => {
  //   // If no targetVideoUrl is provided, show video Iframe, if both are not provided, show snackbar message
  //   if (!targetUrl) {
  //     enqueueSnackbar(snackBarMessage, { variant: snackBarVariant });
  //   } else {
  //     setTargetUrl(targetUrl);
  //     setTransition(true);
  //   }
  // };
  const {
    transition,
    targetUrl,
    showVideo,
    currentVideoUrl,
    triggerTransition,
    handleVideoEnd,
  } = useBlurbAction();
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#F6F6EE",
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        alignItems: "center",
      }}
    >
      {showVideo && (
        <AutoCloseIframeVideo
          videoUrl={currentVideoUrl}
          onClose={handleVideoEnd}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 9999,
          }}
          videoStyle={{
            width: "90vw",
            height: "90vw",
          }}
        />
      )}
      <TransitionComponent targetUrl={targetUrl} transitionState={transition} />

      <Blurb
        lottieIndex={0}
        buttonText="燕园校区总图"
        buttonType="main"
        onClick={triggerTransition(
          targetUrls.campusMap,
          targetVideoUrls.campusMap,
        )}
        lottieProps={
          matchesHeightLessThan700 ? lottiePropsSmallHeight : lottieProps
        }
      />

      {/* 全部专题 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: matchesHeightLessThan700 ? 0 : 2,
        }}
      >
        <Fade in={showProject} timeout={1500}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              zIndex: 9998, //不能高于TransitionComponent和AutoCloseIframeVideo
              gap: {
                xs: 2,
                sm: 4,
                md: 6,
              },
            }}
          >
            <Blurb
              lottieIndex={3}
              buttonText="燕园石刻"
              buttonType="project"
              lottieProps={
                matchesHeightLessThan700
                  ? lottiePropsProjectSmallHeight
                  : lottiePorpsProject
              }
              disabled={
                targetUrls.projects.stone === "" &&
                targetVideoUrls.projects.stone === ""
              }
              onClick={triggerTransition(
                targetUrls.projects.stone,
                targetVideoUrls.projects.stone,
              )}
              sx={{
                // position: "relative",
                // top: "80%",
                transform: "translateY(80%)",
              }}
            />
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onMouseEnter={() => setHoveredRevolution(true)}
              onMouseLeave={() => setHoveredRevolution(false)}
            >
              <Blurb
                lottieIndex={5}
                buttonText="星火百年 民主科学"
                buttonType="project"
                lottieProps={
                  matchesHeightLessThan700
                    ? lottiePropsProjectSmallHeight
                    : lottiePorpsProject
                }
                disabled={
                  targetUrls.projects.revolution === "" &&
                  targetVideoUrls.projects.revolution === ""
                }
                onClick={triggerTransition(
                  targetUrls.projects.revolution,
                  targetVideoUrls.projects.revolution,
                )}
              />
              <Fade in={hoveredRevolution} timeout={300}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    textAlign: "center",
                    color: "#42210B",
                    fontSize: {
                      xs: 11,
                      sm: 12,
                      md: 14,
                    },
                    fontWeight: 700,
                    letterSpacing: 1,
                    mt: -1,
                    whiteSpace: "nowrap",
                    lineHeight: 1.6,
                  }}
                >
                  <br />
                  ——燕园革命文物与精神文脉展
                </Box>
              </Fade>
            </Box>
            <Blurb
              lottieIndex={4}
              buttonText="文物建筑"
              buttonType="project"
              lottieProps={
                matchesHeightLessThan700
                  ? lottiePropsProjectSmallHeight
                  : lottiePorpsProject
              }
              sx={{
                transform: "translateY(80%)",
              }}
              disabled={
                targetUrls.projects.building === "" &&
                targetVideoUrls.projects.building === ""
              }
              onClick={triggerTransition(
                targetUrls.projects.building,
                targetVideoUrls.projects.building,
              )}
            />
          </Box>
        </Fade>
        <Blurb
          lottieIndex={1}
          buttonText="专题"
          buttonType="main"
          lottieProps={
            matchesHeightLessThan700 ? lottiePropsSmallHeight : lottieProps
          }
          onClick={() => {
            setShowProject(true);
          }}
        />
        <Fade in={showProject} timeout={1500}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Blurb
              lottieIndex={6}
              buttonText="燕南园历史建筑"
              buttonType="project"
              lottieProps={
                matchesHeightLessThan700
                  ? lottiePropsProjectSmallHeight
                  : lottiePorpsProject
              }
              disabled={
                targetUrls.projects.yannanyuan === "" &&
                targetVideoUrls.projects.yannanyuan === ""
              }
              onClick={triggerTransition(
                targetUrls.projects.yannanyuan,
                targetVideoUrls.projects.yannanyuan,
              )}
              sx={{
                mr: {
                  xs: 3,
                  sm: 7,
                  md: 12,
                },
              }}
            />
            <Blurb
              lottieIndex={7}
              buttonText="燕东园历史建筑"
              buttonType="project"
              lottieProps={
                matchesHeightLessThan700
                  ? lottiePropsProjectSmallHeight
                  : lottiePorpsProject
              }
              disabled={
                targetUrls.projects.yandongyuan === "" &&
                targetVideoUrls.projects.yandongyuan === ""
              }
              onClick={triggerTransition(
                targetUrls.projects.yandongyuan,
                targetVideoUrls.projects.yandongyuan,
              )}
            />
          </Box>
        </Fade>
      </Box>

      <Blurb
        lottieIndex={2}
        buttonText="燕园时光机"
        buttonType="main"
        lottieProps={
          matchesHeightLessThan700 ? lottiePropsSmallHeight : lottieProps
        }
        onClick={triggerTransition(
          targetUrls.timeMachine,
          targetVideoUrls.timeMachine,
        )}
      />
    </Box>
  );
}
